module.exports = __webpack_public_path__ + "img/ccf-ja-JP.578eb641.png";